export const DefaultPage = 0;
export const PaginationSizes = [10, 25, 100];
export const DefaultPageSize = PaginationSizes[1];
